import { Alert, Banner, Button, ToastProvider, useToast } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable, DoDont } from "../../components/DocChrome";

function ToastDemo() {
    const { push } = useToast();
    return (
        <div className="flex flex-wrap gap-2">
            <Button
                size="sm"
                onClick={() =>
                    push({ title: "Synced", message: "12 deliveries uploaded", tone: "success" })
                }
            >
                Success toast
            </Button>
            <Button
                size="sm"
                variant="outline"
                onClick={() =>
                    push({
                        title: "Offline",
                        message: "Queue will flush when online",
                        tone: "warning",
                    })
                }
            >
                Warning
            </Button>
            <Button
                size="sm"
                variant="danger"
                onClick={() =>
                    push({
                        title: "Payment failed",
                        message: "Safepay declined the charge",
                        tone: "danger",
                    })
                }
            >
                Danger
            </Button>
            <Button
                size="sm"
                variant="ghost"
                onClick={() => push({ message: "Profile updated", tone: "info" })}
            >
                Info
            </Button>
        </div>
    );
}

export function FeedbackPage() {
    return (
        <DocPage
            title="Feedback & Messaging"
            description="Hallmark toast: tonal icons, restrained chrome. Prefer silent success when the UI already updates."
        >
            <Section title="How it looks">
                <Demo className="space-y-3">
                    <Banner tone="warning" title="Subscription past due">
                        Renew to restore rider sync for this tenant.
                    </Banner>
                    <Alert tone="info" title="Informational">
                        Safepay credentials are configured for this tenant.
                    </Alert>
                    <Alert tone="danger" title="Error">
                        Payment webhook failed validation.
                    </Alert>
                    <ToastProvider>
                        <ToastDemo />
                    </ToastProvider>
                </Demo>
            </Section>
            <Section title="Decision guide">
                <SpecTable
                    rows={[
                        ["Banner", "Page-level persistent condition"],
                        ["Alert", "In-content persistent message"],
                        ["Toast", "Transient async / failure outcomes"],
                        ["Silent success", "Skip toast if the result is already visible"],
                    ]}
                />
            </Section>
            <DoDont
                doItems={["Tone icons + clear dismiss", "Longer duration for danger toasts"]}
                dontItems={["Celebrate every save with a toast", "Use toast for field validation"]}
            />
        </DocPage>
    );
}
